export const gridLineOption = showGridlines => ({
  gridLineDashStyle: 'dash',
  gridLineColor: '#E1E5EB',
  gridLineWidth: showGridlines ? 1 : 0,
});

export const stackingOption = isStacked => ({
  stacking: isStacked ? 'normal' : undefined,
});

export const showZoomButtonsEvent = (showZoomButtons, callbacks) => ({
  afterSetExtremes: (event) => {
    const {
      max, min, dataMax, dataMin,
    } = event;
    showZoomButtons(min > dataMin || max < dataMax);
    callbacks?.forEach(cb => cb(event));
  },
});
